// Components==============
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React, { SetStateAction } from 'react';
import { interactiveScale } from 'utilities/FramerAnimations';
import './MessageBar.module.scss';
// =========================

type Props = {
  inputValue: string;
  setInputValue: React.Dispatch<SetStateAction<string>>;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
  paddingRight?: string;
};

export default function MessageBar({
  inputValue,
  setInputValue,
  handleSubmit,
  inputRef,
  paddingRight,
}: Props) {
  const translate = useTranslate();

  return (
    <form onSubmit={handleSubmit} styleName="wrapper" style={{ paddingRight }}>
      <input
        type="text"
        onChange={(event) => setInputValue(event.target.value)}
        value={inputValue}
        placeholder={translate('work.feedback.input-placeholder') as string}
        ref={inputRef}
      />
      <motion.button {...interactiveScale} type="submit">
        <FontAwesomeIcon icon={faPaperPlane} />
      </motion.button>
    </form>
  );
}
